import { Button } from 'theme-ui';

import { Svg } from '@snippets';

import { themed } from './Navigation.theme';

export const NavigationButton = themed(
  ({
    theme,
    src = '/svgs/chevron/left.svg#left',
    alt = 'Previous product',
    isNext = false,
    arrowColor,
    inputRef,
    ...props
  }) => {
    return (
      <Button
        data-comp={NavigationButton.displayName}
        {...props}
        variant="buttons.plain"
        sx={{
          ...(isNext ? theme.buttonNext : theme.buttonPrev),
          ...props.sx,
        }}
      >
        <Svg
          alt={alt}
          src={src}
          viewBox="0 0 16 16"
          draggable={false}
          sx={{ ...theme.icon, color: arrowColor }}
        />
      </Button>
    );
  }
);

NavigationButton.displayName = 'NavigationButton';